// Line animation utility with reset capability
export const initLineAnimations = () => {
  // Create intersection observer for line animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const target = entry.target;
      
      if (entry.isIntersecting) {
        // Reset the animation first by removing the class
        target.classList.remove('animate-line-in');
        
        // Use requestAnimationFrame to ensure the removal is processed
        requestAnimationFrame(() => {
          target.classList.add('animate-line-in');
        });
      } else {
        // Remove the animation when out of view so it can replay when scrolling back
        target.classList.remove('animate-line-in');
      }
    });
  }, {
    threshold: 0.1, // Lower threshold for earlier trigger
    rootMargin: '0px 0px -100px 0px' // Trigger when element is 100px from bottom of viewport
  });

  // Target specific line elements
  const lineElements = document.querySelectorAll(
    '.decorative-line-top, .decorative-line-bottom, .animated-section-divider, .card-divider, #deco-line, #line'
  );

  lineElements.forEach(element => {
    element.classList.add('animate-line');
    observer.observe(element);
  });

  return observer;
};